import { gql } from '@apollo/client';

export const GET_UOM_LIST = gql`
  query SearchUoms {
    searchUoms {
      items {
        id
        abbreviation
        description
      }
    }
  }
`;
